import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { isEmptyObject } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class CustomFieldsForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      customFields: props.customFields,
      enteredCustomFields: {},
    }
    this.validator =
      this.props.validator || validatorFactory({ autoForceUpdate: this })
    this.handleCustomFieldChange = this.handleCustomFieldChange.bind(this)
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.props.handleCustomFields(this.state.enteredCustomFields)
    }
  }

  handleCustomFieldChange(event) {
    const name = event.target.name
    const value = event.target.value
    this.setState({
      enteredCustomFields: { ...this.state.enteredCustomFields, [name]: value },
    })
  }

  generateCustomFields() {
    if (!isEmptyObject(this.state.customFields)) {
      return this.state.customFields.map((field) => {
        return (
          <FormGroup
            key={field.key}
            name={field.key}
            label={field.title}
            value={this.state.enteredCustomFields[field.key]}
            onChange={this.handleCustomFieldChange}
            disabled={this.props.disabled}
            validation={
              field.required &&
              this.validator.message(
                field.key,
                this.state.enteredCustomFields[field.key],
                "required",
                { messages: { default: "This field is required." } }
              )
            }
          />
        )
      })
    }
  }

  render() {
    return (
      <div>
        {!this.props.embedForm && (
          <p>Additional info {this.props.marinaName} needs from you.</p>
        )}
        {this.generateCustomFields()}
        {this.props.embedForm ? (
          <LegacyButton
            icon={this.props.icon}
            type={this.props.buttonType}
            className={this.props.buttonClassName}
            disabled={this.props.disabled}
            processingText={this.props.processingText}
            onClick={this.finish.bind(this)}
          >
            {this.props.buttonText}
          </LegacyButton>
        ) : (
          <NextButton
            click={this.finish.bind(this)}
            icon=""
            text="Continue"
            btnClass="btn btn-primary w-full"
          />
        )}
      </div>
    )
  }
}

CustomFieldsForm.propTypes = {
  customFields: PropTypes.array.isRequired,
  handleCustomFields: PropTypes.func.isRequired,
  marinaName: PropTypes.string,
  embedForm: PropTypes.bool,
  disabled: PropTypes.bool,
  validator: PropTypes.object,
  icon: PropTypes.string,
  buttonType: PropTypes.string,
  buttonClassName: PropTypes.string,
  processingText: PropTypes.string,
  buttonText: PropTypes.string,
  context: PropTypes.object,
}

export default CustomFieldsForm
